import { Button, Icon, IconButton, Typography } from "@mui/material"
import { CustomPaper } from "../../../../../../../components/CustomPaper"
import BaseModal from "../../../../../../../components/modal/baseModal"
import { useStyles } from "./styles"
import { TimeOutProps } from "./type"
import { icons } from "../../../../../../../utils/icons"
import { useTranslation } from "react-i18next"

function TimeOut({ modalProps, title, action, close }: TimeOutProps) {
    const { t } = useTranslation()
    const styles = useStyles()

    return (
        <BaseModal sx={{ width: '310px' }} {...modalProps} open={!!modalProps?.open}>
            <CustomPaper sx={styles.container} elevation={0}>
                <IconButton sx={styles.close} onClick={close}>{icons('simple-close')}</IconButton>

                <Icon color="primary" sx={styles.icon}>{icons('timer')}</Icon>

                <Typography variant="subtitle" textAlign={"center"} fontWeight='bold'>{title}</Typography>

                <Button fullWidth onClick={action} variant="primary_c_nr">{t('actionPlan.reassignActionPlan')}</Button>
            </CustomPaper>
        </BaseModal>
    )
}

export default TimeOut